export const getEventRadiusKilometers = () => {
  const radius = [];
  for (let i = 20; i <= 100; i += 5) {
    radius.push({ label: `${i} Km`, value: i });
  }
  return radius;
};
